import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController } from 'ionic-angular';
import { DadosProvider } from '../../providers/dados/dados';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ViewProvider } from '../../providers/view/view';
import { EnderecoPage } from '../endereco/endereco';

@Component({
  selector: 'page-endereco-list',
  templateUrl: 'endereco-list.html',
})
export class EnderecoListPage {

  enderecos:Array<any> = [];

  enderecoPadrao;
  isModal = false;
  constructor(public navCtrl: NavController, private server:SemovelProvider, private view:ViewProvider, private dadosP:DadosProvider,
    private navParams:NavParams, private viewCtrl:ViewController) {
    
    this.isModal = navParams.get('modal');
  }

  ionViewDidEnter(){
    this.enderecoPadrao = this.dadosP.endereco;
    
    this.server.postData({method:"cliente/enderecos"})
    .subscribe(
      (response) => this.enderecos = response,
      (err) => console.error(err)
    );
  }

  adicionarEndereco(){
    this.navCtrl.push(EnderecoPage);  
  }

  editarEndereco(endereco){
    this.navCtrl.push(EnderecoPage, {endereco})
    .then(
      (dados) => {
        console.log("retorno adicao endereco",dados);
      }
    );  
  }

  marcarPadrao(endereco){
    this.dadosP.salvarEndereco(endereco);
    this.enderecoPadrao = endereco;

    if(this.isModal){
      // fechar e trazer o endereço
      this.viewCtrl.dismiss({endereco});
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/endereco-list/endereco-list.ts